/*
 *  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  ~ No part of this publication may be reproduced, distributed,
 *  ~ or transmitted in any form or by any means, including photocopying, recording,
 *  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  ~ except in the case of brief quotations embodied in critical
 *  ~ reviews and certain other noncommercial uses permitted by copyright law.
 *  ~ Author : BS
 *  ~ Date : 2/8/23, 11:19 AM
 */

import { AoReportDeviceDetail } from './ao-report-device-detail';
import { IEntity } from '@infodata-group/inf-commons';

export class AoReportDevice implements IEntity {
  id: string;
  label: string;
  bbx: string;
  date: string;
  begin: string;
  end: string;
  total: string;
  enable: string;
  disable: string;
  detail: AoReportDeviceDetail[] = [];
  lock: boolean;

  constructor() {}

  getId(): string {
    return this.id;
  }

  getLabel(): string {
    return this.label;
  }

  serialize(): any {}
}
